import { BusinessConcept, DataSource, KeyResult } from './types';

export const KEY_RESULTS: KeyResult[] = [
  {
    displayName: 'KR Account Management',
    description:
      'Handles the creation, modification, and closure of customer accounts.',
  },
  {
    displayName: 'KR Loan Processing',
    description:
      'Manages the application, approval, and disbursement of loans.',
  },
  {
    displayName: 'KR Payment Processing',
    description:
      'Facilitates the processing and settlement of customer payments.',
  },
  {
    displayName: 'KR Fraud Detection',
    description:
      'Identifies and prevents fraudulent activities within the banking system.',
  },
];

export const BUSINESS_CONCEPTS: BusinessConcept[] = [
  {
    displayName: 'Account Management',
    domain: 'Retail Banking',
    description:
      'Handles the creation, modification, and closure of customer accounts.',
  },
  {
    displayName: 'Loan Processing',
    domain: 'Retail Banking',
    description:
      'Manages the application, approval, and disbursement of loans.',
  },
  {
    displayName: 'Payment Processing',
    domain: 'Retail Banking',
    description:
      'Facilitates the processing and settlement of customer payments.',
  },
  {
    displayName: 'Fraud Detection',
    domain: 'Risk Management',
    description:
      'Identifies and prevents fraudulent activities within the banking system.',
  },
  {
    displayName: 'Risk Management',
    domain: 'Risk Management',
    description:
      'Evaluates and mitigates potential risks associated with banking operations.',
  },
  {
    displayName: 'Customer Relationship Management (CRM)',
    domain: 'Retail Banking',
    description:
      'Manages customer interactions, inquiries, and relationship building.',
  },
  {
    displayName: 'Wealth Management',
    domain: 'Investment Banking',
    description:
      'Provides personalized financial planning and investment advice.',
  },
  {
    displayName: 'Credit Card Processing',
    domain: 'Retail Banking',
    description:
      'Handles the authorization and processing of credit card transactions.',
  },
  {
    displayName: 'Treasury Management',
    domain: 'Corporate Banking',
    description:
      'Manages cash flow, liquidity, and financial assets for businesses.',
  },
  {
    displayName: 'Online Banking',
    domain: 'Retail Banking',
    description:
      'Enables customers to perform banking transactions through digital channels.',
  },
  {
    displayName: 'Mobile Banking',
    domain: 'Retail Banking',
    description:
      'Allows customers to access banking services through mobile devices.',
  },
  {
    displayName: 'Mortgage Lending',
    domain: 'Retail Banking',
    description:
      'Offers loans for purchasing or refinancing real estate properties.',
  },
  {
    displayName: 'Investment Banking',
    domain: 'Investment Banking',
    description:
      'Provides financial advisory and capital raising services to corporations.',
  },
  {
    displayName: 'Foreign Exchange (Forex) Trading',
    domain: 'Investment Banking',
    description: 'Facilitates the buying and selling of foreign currencies.',
  },
  {
    displayName: 'ATM Management',
    domain: 'Retail Banking',
    description:
      'Oversees the operation and maintenance of automated teller machines.',
  },
  {
    displayName: 'Compliance Monitoring',
    domain: 'Risk Management',
    description:
      'Ensures adherence to regulatory requirements and internal policies.',
  },
  {
    displayName: 'Data Analytics',
    domain: 'Risk Management',
    description:
      'Analyzes large volumes of data to gain insights and make informed decisions.',
  },
  {
    displayName: 'Anti-Money Laundering (AML)',
    domain: 'Risk Management',
    description:
      'Detects and prevents money laundering activities within the banking system.',
  },
  {
    displayName: 'Trade Finance',
    domain: 'Corporate Banking',
    description:
      'Provides financing and risk mitigation services for international trade transactions.',
  },
  {
    displayName: 'Branch Operations',
    domain: 'Retail Banking',
    description: 'Manages the day-to-day operations of physical bank branches.',
  },
];

export const DATA_SOURCES: DataSource[] = [
  { displayName: 'Customers', domain: 'organization' },
  { displayName: 'Leads', domain: 'marketing' },
  { displayName: 'Sales Customers', domain: 'sales' },
  { displayName: 'Sales Orders', domain: 'sales' },
  { displayName: 'Sales Products', domain: 'sales' },
  { displayName: 'Accounts', domain: 'finance' },
  { displayName: 'Invoices', domain: 'finance' },
  { displayName: 'Payments', domain: 'finance' },
  { displayName: 'Cash Flows', domain: 'finance' },
  { displayName: 'Movements', domain: 'finance' },
  { displayName: 'Transactions', domain: 'finance' },
  { displayName: 'Loans', domain: 'finance' },
  { displayName: 'Credit Cards', domain: 'finance' },
  { displayName: 'Investments', domain: 'finance' },
  { displayName: 'Insurance Policies', domain: 'finance' },
  { displayName: 'Bank Accounts', domain: 'finance' },
  { displayName: 'ATM Transactions', domain: 'finance' },
  { displayName: 'Online Banking', domain: 'finance' },
];
